/*
 * Expandable entry cards - the mobile accordion for the Entries grid (Tab) section.
 *
 * Ported from the 1LE live theme's theme.js, which this theme does not include.
 * Without it the collapsed cards can never open, so at <=768px every card except
 * the first stays permanently shrunk.
 *
 * Two deliberate differences from the original:
 *   - delegated off document, so it keeps working after the theme editor
 *     re-renders a section
 *   - scoped to the containing tab panel, so opening a card in one tab does not
 *     leave the other tab with no card open
 */
(function () {
  'use strict';

  function scopeFor(card) {
    return (
      card.closest('[role="tabpanel"]') ||
      card.closest('.entries-product-collection') ||
      document
    );
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var card = target.closest('.expandable-card');
    if (!card) return;

    var scope = scopeFor(card);
    scope.querySelectorAll('.expandable-card').forEach(function (other) {
      if (other !== card) other.classList.remove('active');
    });
    card.classList.add('active');
  });
})();
